import React from 'react';
import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 24, className = '' }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionEyebrow = ({ children }) => (
  <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#00A651]">
    {children}
  </div>
);

export const SectionTitle = ({ children, className = '' }) => (
  <h2 className={`font-[\'Outfit\'] text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0B0F0C] ${className}`}>
    {children}
  </h2>
);

export const SectionBody = ({ children, className = '' }) => (
  <p className={`text-base lg:text-lg text-[#5C5C5C] leading-relaxed ${className}`}>
    {children}
  </p>
);

export const Container = ({ children, className = '' }) => (
  <div className={`max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 ${className}`}>
    {children}
  </div>
);
